/* global axios */

import ApiClient from './ApiClient';

class InvoicesAPI extends ApiClient {
  constructor() {
    super('invoices', { accountScoped: true });
  }

  createForConversation(conversationId, { provider, items }) {
    return axios.post(
      `${this.baseUrl()}/conversations/${conversationId}/invoices`,
      { invoice: { provider, items } }
    );
  }

  getForContact(contactId) {
    return axios.get(`${this.baseUrl()}/contacts/${contactId}/invoices`);
  }

  verify(invoiceId) {
    return axios.post(`${this.url}/${invoiceId}/verify`);
  }

  void(invoiceId) {
    return axios.post(`${this.url}/${invoiceId}/void`);
  }

  createPayment(invoiceId, provider) {
    return axios.post(`${this.url}/${invoiceId}/payments`, { provider });
  }

  refund(invoiceId, mobile) {
    return axios.post(`${this.url}/${invoiceId}/refund`, { mobile });
  }
}

export default new InvoicesAPI();
